import React from 'react';
import { Box, Typography, AppBar, Toolbar, IconButton, Container, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

function PrivacyPage() {
  const navigate = useNavigate();
  
  return (
    <>
      <SEO 
        title="개인정보처리방침 | 스냅로그"
        description="스냅로그의 개인정보 수집 및 이용에 대한 안내입니다. 사용자의 개인정보 보호를 위해 노력하고 있습니다."
        url="/privacy"
      />
      <Box sx={{ minHeight: '100vh', bgcolor: '#f8f9fa' }}>
      <AppBar position="static" color="inherit" elevation={0} sx={{ borderBottom: '1px solid #eee', bgcolor: '#fff' }}>
        <Toolbar sx={{ minHeight: 56, px: 2 }}>
          <IconButton edge="start" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flex: 1, fontWeight: 700, ml: 1 }}>개인정보처리방침</Typography>
        </Toolbar>
      </AppBar>
      
      <Container maxWidth="md" sx={{ mt: 2, mb: 4, px: 2 }}>
        <Paper elevation={0} sx={{ p: 3, bgcolor: '#fff', borderRadius: 2 }}>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.8, 
            fontSize: '0.95rem',
            mb: 3,
            textAlign: 'justify'
          }}>
            스냅로그(SnapLog)는 사용자 개인정보를 소중하게 생각하며, 「개인정보 보호법」 등 관련 법령에 따라 이용자의 개인정보를 안전하게 보호하고 있습니다. 본 방침은 스냅로그에서 제공하는 웹서비스 이용과 관련하여 수집되는 개인정보의 처리 목적, 수집 항목, 보관 기간, 이용자의 권리 등을 안내합니다.
          </Typography>

          <Typography variant="h6" sx={{ 
            fontWeight: 700, 
            color: '#222', 
            mb: 2, 
            mt: 4,
            fontSize: '1.1rem'
          }}>
            1. 수집하는 개인정보 항목
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 1,
            pl: 2
          }}>
            • (필수) Google 계정을 통한 로그인 시 수집: 이메일 주소, 이름, 프로필 이미지
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 1,
            pl: 2
          }}>
            • (선택) 사용자가 직접 입력하는 독서 기록(책 제목, 하이라이트, 메모 등)
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 3,
            pl: 2
          }}>
            • (자동) 서비스 이용 과정에서 생성되는 정보: 접속 로그, 기기 정보, 쿠키, IP 주소 등
          </Typography>

          <Typography variant="h6" sx={{ 
            fontWeight: 700, 
            color: '#222', 
            mb: 2, 
            mt: 4,
            fontSize: '1.1rem'
          }}>
            2. 개인정보 수집 및 이용 목적
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 1,
            pl: 2
          }}>
            • 계정 식별 및 사용자 맞춤 서비스 제공
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 1,
            pl: 2
          }}>
            • 사용자가 작성한 독서 기록의 저장 및 연동
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 1,
            pl: 2
          }}>
            • 서비스 운영 및 품질 개선을 위한 통계 분석
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 3,
            pl: 2
          }}>
            • Google AdSense 기반 광고 제공
          </Typography>

          <Typography variant="h6" sx={{ 
            fontWeight: 700, 
            color: '#222', 
            mb: 2, 
            mt: 4,
            fontSize: '1.1rem'
          }}>
            3. 보유 및 이용 기간
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 1,
            pl: 2
          }}>
            • 회원 탈퇴 시까지 (단, 관계 법령에 따라 보관이 필요한 경우 해당 기간 동안 보관)
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 3,
            pl: 2
          }}>
            • 광고 및 분석 데이터: Google 측 정책에 따름
          </Typography>

          <Typography variant="h6" sx={{ 
            fontWeight: 700, 
            color: '#222', 
            mb: 2, 
            mt: 4,
            fontSize: '1.1rem'
          }}>
            4. 개인정보 제3자 제공
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 1,
            pl: 2
          }}>
            • Google (AdSense 및 Google Analytics 사용 시)
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 3,
            pl: 2
          }}>
            • 그 외 사용자 동의 없는 외부 제공 없음
          </Typography>

          <Typography variant="h6" sx={{ 
            fontWeight: 700, 
            color: '#222', 
            mb: 2, 
            mt: 4,
            fontSize: '1.1rem'
          }}>
            5. 개인정보 처리 위탁
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 3,
            pl: 2
          }}>
            • 현재 개인정보 처리 위탁은 하지 않으며, 위탁 발생 시 별도 고지 예정
          </Typography>

          <Typography variant="h6" sx={{ 
            fontWeight: 700, 
            color: '#222', 
            mb: 2, 
            mt: 4,
            fontSize: '1.1rem'
          }}>
            6. 이용자의 권리 및 행사 방법
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 1,
            pl: 2
          }}>
            • 이메일(usernamegsh@gmail.com)을 통해 열람·정정·삭제·처리정지 요청 가능
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 3,
            pl: 2
          }}>
            • Google 계정 연결 해제를 통해 서비스 탈퇴 및 데이터 삭제 가능
          </Typography>

          <Typography variant="h6" sx={{ 
            fontWeight: 700, 
            color: '#222', 
            mb: 2, 
            mt: 4,
            fontSize: '1.1rem'
          }}>
            7. 개인정보 보호를 위한 노력
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 1,
            pl: 2
          }}>
            • 개인정보는 Firebase 등 신뢰성 있는 클라우드 환경에 암호화 저장되며, 관리자 외 열람이 불가능합니다.
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 3,
            pl: 2
          }}>
            • 보안 접근 제한, 주기적 백업 등을 통해 안정성 확보에 최선을 다하고 있습니다.
          </Typography>

          <Typography variant="h6" sx={{ 
            fontWeight: 700, 
            color: '#222', 
            mb: 2, 
            mt: 4,
            fontSize: '1.1rem'
          }}>
            8. 쿠키 사용 안내
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 3,
            pl: 2
          }}>
            • 쿠키는 로그인 상태 유지, 사용성 향상, 광고 타게팅에 사용되며, 사용자는 브라우저 설정을 통해 쿠키 거부 가능
          </Typography>

          <Typography variant="h6" sx={{ 
            fontWeight: 700, 
            color: '#222', 
            mb: 2, 
            mt: 4,
            fontSize: '1.1rem'
          }}>
            9. 정책 변경 안내
          </Typography>
          <Typography variant="body1" sx={{ 
            color: '#333', 
            lineHeight: 1.7, 
            fontSize: '0.95rem',
            mb: 4,
            pl: 2
          }}>
            • 본 방침은 변경될 수 있으며, 중요한 변경 시 웹사이트를 통해 사전 공지합니다.
          </Typography>

          <Box sx={{ 
            mt: 4, 
            pt: 3, 
            borderTop: '1px solid #eee',
            textAlign: 'center'
          }}>
            <Typography variant="body2" sx={{ 
              color: '#666', 
              fontSize: '0.9rem',
              mb: 1
            }}>
              최종 업데이트: 2025년 7월 18일
            </Typography>
            <Typography variant="body2" sx={{ 
              color: '#666', 
              fontSize: '0.9rem'
            }}>
              문의: usernamegsh@gmail.com
            </Typography>
            <Typography variant="body2" sx={{ 
              color: '#666', 
              fontSize: '0.9rem'
            }}>
              네이버 블로그: <a href="https://blog.naver.com/delightplan" target="_blank" rel="noopener noreferrer" style={{ color: '#666', textDecoration: 'underline' }}>https://blog.naver.com/delightplan</a>
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
    </>
  );
}

export default PrivacyPage; 